/* eslint-disable no-console */
import { shouldPolyfill as shouldPolyfillDatetimeformat } from '@formatjs/intl-datetimeformat/should-polyfill.js';
import { shouldPolyfill as shouldPolyfillRelativetimeformat } from '@formatjs/intl-relativetimeformat/should-polyfill.js';
import { shouldPolyfill as shouldPolyfillDisplaynames } from '@formatjs/intl-displaynames/should-polyfill.js';
import { shouldPolyfill as shouldPolyfillNumberFormat } from '@formatjs/intl-numberformat/should-polyfill.js';
import { DateUtils } from '../helpers';

// https://cdn.jsdelivr.net/npm/@formatjs/intl-datetimeformat@6.17.2/locale-data/

export async function polyfillDatetimeFormat(locale: string) {
  const unsupportedLocale = shouldPolyfillDatetimeformat(locale);
  console.log('DatetimeFormat support', { support: !unsupportedLocale });
  // This locale is supported
  if (!unsupportedLocale) {
    return;
  }
  // Load the polyfill 1st BEFORE loading data
  await import('@formatjs/intl-datetimeformat/polyfill-force.js').catch(() => {
    console.error(
      `Failed to load @formatjs/intl-datetimeformat/polyfill-force for ${locale}`,
    );
  });

  // Parallelize CLDR data loading
  const dataPolyfills = [
    import('@formatjs/intl-datetimeformat/add-golden-tz.js'),
    loadIntlDateTimeFormatLocaleData(DateUtils.DEFAULT_LOCALE),
    loadIntlDateTimeFormatLocaleData(locale),
  ];
  await Promise.all(dataPolyfills.filter(Boolean)).catch(() => {});
}

async function loadIntlDateTimeFormatLocaleData(locale: string) {
  return import(
    /* @vite-ignore */
    `https://cdn.jsdelivr.net/npm/@formatjs/intl-datetimeformat@6.17.2/locale-data/${locale}/+esm`
  )
    .catch(() => {
      // try with language only
      const language = locale.split('-')[0];
      return import(
        /* @vite-ignore */
        `https://cdn.jsdelivr.net/npm/@formatjs/intl-datetimeformat@6.17.2/locale-data/${language}/+esm`
      );
    })
    .catch(() => {
      console.error(
        `Failed to load locale data for @formatjs/intl-datetimeformat for ${locale}`,
      );
    });
}

export async function polyfillRelativetimeformat(locale: string) {
  const unsupportedLocale = shouldPolyfillRelativetimeformat(locale);
  console.log('Relativetimeformat support', { support: !unsupportedLocale });
  // This locale is supported
  if (!unsupportedLocale) {
    return;
  }
  // Load the polyfill 1st BEFORE loading data
  await import('@formatjs/intl-relativetimeformat/polyfill-force.js');
  await Promise.all([
    loadIntlRelativeTimeFormatLocaleData(DateUtils.DEFAULT_LOCALE),
    loadIntlRelativeTimeFormatLocaleData(locale),
  ]).catch(() => {});
}

function loadIntlRelativeTimeFormatLocaleData(locale: string) {
  return import(
    /* @vite-ignore */
    `https://cdn.jsdelivr.net/npm/@formatjs/intl-relativetimeformat@11.4.9/locale-data/${locale}/+esm`
  )
    .catch(() => {
      // try with language only
      const language = locale.split('-')[0];
      return import(
        /* @vite-ignore */
        `https://cdn.jsdelivr.net/npm/@formatjs/intl-relativetimeformat@11.4.9/locale-data/${language}/+esm`
      );
    })
    .catch(() => {
      console.error(
        `Failed to load locale data for @formatjs/intl-relativetimeformat for ${locale}`,
      );
    });
}

export async function polyfillDisplayNames(locale: string) {
  const unsupportedLocale = shouldPolyfillDisplaynames(locale);
  console.log('DisplayNames support', { support: !unsupportedLocale });
  // This locale is supported
  if (!unsupportedLocale) {
    return;
  }
  // Load the polyfill 1st BEFORE loading data
  await import('@formatjs/intl-displaynames/polyfill-force.js');
  await Promise.all([
    loadIntlDisplayNamesLocaleData(locale),
    loadIntlDisplayNamesLocaleData(DateUtils.DEFAULT_LOCALE),
  ]);
}

function loadIntlDisplayNamesLocaleData(locale: string) {
  return import(
    /* @vite-ignore */
    `https://cdn.jsdelivr.net/npm/@formatjs/intl-displaynames@6.8.9/locale-data/${locale}/+esm`
  )
    .catch(() => {
      // try with language only
      const language = locale.split('-')[0];
      return import(
        /* @vite-ignore */
        `https://cdn.jsdelivr.net/npm/@formatjs/intl-displaynames@6.8.9/locale-data/${language}/+esm`
      );
    })
    .catch(() => {
      console.error(
        `Failed to load locale data for @formatjs/intl-displaynames for ${locale}`,
      );
    });
}

export async function polyfillNumberFormat(locale: string) {
  const unsupportedLocale = shouldPolyfillNumberFormat(locale);
  console.log('NumberFormat support', { support: !unsupportedLocale });
  // This locale is supported
  if (!unsupportedLocale) {
    return;
  }
  // Load the polyfill 1st BEFORE loading data
  await import('@formatjs/intl-numberformat/polyfill-force.js');
  await Promise.all([
    loadIntlNumberFormatLocaleData(DateUtils.DEFAULT_LOCALE),
    loadIntlNumberFormatLocaleData(locale),
  ]).catch(() => {});
}
function loadIntlNumberFormatLocaleData(locale: string) {
  return import(
    /* @vite-ignore */
    `https://cdn.jsdelivr.net/npm/@formatjs/intl-numberformat@18.15.2/locale-data/${locale}/+esm`
  )
    .catch(() => {
      // try with language only
      const language = locale.split('-')[0];
      return import(
        /* @vite-ignore */
        `https://cdn.jsdelivr.net/npm/@formatjs/intl-numberformat@18.15.2/locale-data/${language}/+esm`
      );
    })
    .catch(() => {
      console.error(
        `Failed to load locale data for @formatjs/intl-numberformat for ${locale}`,
      );
    });
}
